import React, { ReactElement, useState } from "react";

import { Accordion, Button, Card, useAccordionButton } from "react-bootstrap";

import { MinusIcon, PlusSymbol } from "@assets/icons";

import styles from "./FAQAccordion.module.scss";

const CustomToggle = ({
  eventKey,
  activeTabs,
  setActiveTabs,
}: {
  eventKey: string;
  activeTabs: string[];
  setActiveTabs: React.Dispatch<React.SetStateAction<string[]>>;
}) => {
  const decoratedOnClick = useAccordionButton(eventKey, () =>
    setActiveTabs((prev) => (prev.includes(eventKey) ? prev.filter((key) => key !== eventKey) : [...prev, eventKey])),
  );

  return (
    <Button variant="plain" onClick={decoratedOnClick} className={styles["faq-button"]}>
      <img src={activeTabs.includes(eventKey) ? MinusIcon : PlusSymbol} />
      <div className="b1 ps-2 text-start medium">{eventKey}</div>
    </Button>
  );
};

export type QNA = { question: string; answer: string | ReactElement };

const FAQAccordion = ({ qnas }: { qnas: QNA[] }) => {
  const [activeTabs, setActiveTabs] = useState<string[]>([]);
  return (
    <Accordion alwaysOpen activeKey={activeTabs}>
      {qnas.map((qna) => (
        <Card className="border-0" key={qna.question}>
          <Card.Header
            className={
              activeTabs.includes(qna.question) ? styles["faq-button-wrapper-active"] : styles["faq-button-wrapper"]
            }
          >
            <CustomToggle eventKey={qna.question} activeTabs={activeTabs} setActiveTabs={setActiveTabs} />
          </Card.Header>
          <Accordion.Collapse eventKey={qna.question}>
            <Card.Body className={styles["faq-answer-wrapper-active"]}>
              {typeof qna.answer === "string" ? <div className="b2">{qna.answer}</div> : qna.answer}
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      ))}
    </Accordion>
  );
};

export default FAQAccordion;
